<template>
  <div>
    <!-- 分页 -->
    <el-pagination
      v-model:currentPage="page"
      v-model:pageSize="limit"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
	  :page-size="limit"
      :total="data.total"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: this.data.page, //当前页数
      limit: this.data.limit, //当前条数
    };
  },
  props: ["data"], //父传子 接收总条数
  methods: {
    back() {
      //回到顶部的立即调用
	  document.documentElement.scrollTop = 0;
    },
	handleCurrentChange(val){
		this.page = val
		this.$nextTick(()=>{
		this.$emit("pageChange", val);
		this.back()
		})
	}
  },
};
</script>

<style scoped>
	.el-pagination {
		line-height: 30px;
		padding: 30px;
	}
</style>
